<template>
  <div>
    <!--PASSWORD-->
    <b-form-group :class="{ 'form-group--error': $v.user.password.$error }">
      <div class="row">
        <mdb-input id="password" v-model.trim="$v.user.password.$model"
                   class="form_input_margin" icon="lock"
                   label="Your password" type="password" @focusout="passPwd"/>
        <span id="view-pwd" v-b-tooltip.hover
              :title="'see raw password'"
              aria-hidden="true" class="fa fa-fw fa-eye"
              @click="viewPassword()"/>
      </div>
      <div v-if="$v.user.password.$dirty">
        <div v-if="!$v.user.password.required" class="error">Field is required</div>
        <div v-if="!$v.user.password.strongPassword" class="error">
          Strong passwords need to have a letter, a number, a special
          character, and be more than 8 characters long..
        </div>
      </div>
    </b-form-group>

    <!--REPEAT PASSWORD-->
    <div @focusout="passPwd">
      <b-form-group
          :class="{ 'form-group--error': $v.user.confirmPassword.$error }">
        <mdb-input
            id="confirmPassword"
            v-model.trim="$v.user.confirmPassword.$model"
            icon="exclamation-triangle"
            label="Confirm your password"
            type="password"/>
        <div v-if="$v.user.confirmPassword.$dirty">
          <div v-if="!$v.user.confirmPassword.required" class="error">Field is required</div>
          <div v-if="!$v.user.confirmPassword.sameAsPassword" class="error">Passwords must be identical!</div>
        </div>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import {mdbInput} from "mdbvue";
import EventBus from "@/components/EventBus";
import {required, sameAs} from "vuelidate/lib/validators";

export default {
  name: "Password_ConfirmPasswordComponent",
  data(){
    return {
      user: {
        password: '',
        confirmPassword: '',
      }
    }
  },

  validations: {
    user: {
      password: {
        required,
        strongPassword(password1) {
          return (
              /[a-z]/.test(password1) && //checks for a-z
              /[0-9]/.test(password1) && //checks for 0-9
              /\W|_/.test(password1) && //checks for special char
              password1.length >= 6
          );
        }
      },
      confirmPassword: {required, sameAsPassword: sameAs('password')}
    }
  },

  methods: {
    viewPassword() {
      let passwordInput = document.getElementById('password');
      let pwdEyeIcon = document.getElementById('view-pwd');

      if (passwordInput.type === 'password') {
          passwordInput.type = 'text';
          pwdEyeIcon.className = 'fa fa-eye-slash';
      } else {
          passwordInput.type = 'password';
          pwdEyeIcon.className = 'fa fa-eye';
      }
    },

    passPwd(){
      EventBus.$emit('setPwd', this.user.password)
    }
  },
  components: {mdbInput},
}
</script>
